import React, { useEffect, useState } from 'react';
import { Input, Row, Col, Form, Select, Tabs } from 'antd';
import {useDispatch, useSelector} from 'react-redux';

import { InputNCM } from '../custom-inputs/input-ncm';
import {  atualizaProduto, getActions} from '../store/cadastro-produto.reducer';
import { InputNumero } from '../../../Numeros/input-numero';
import { newProduto } from '../store/produto.domain';
const { TabPane } = Tabs;
const TabTributacao = ({getApi, dataTab}) => {


    const { Option } = Select;

    // const {atualizaProduto} = getActions() 
    const dispatch = useDispatch();
    const {produto:dadosProduto} = useSelector(state => state.produto);
    const produto = newProduto(dadosProduto);

    const {firstErrorField} = useSelector(state=>state.produto);

    const [activeKey, setActiveKey] = useState("geral");

    useEffect(()=> {
       
        
        if(firstErrorField){
            const element = document.getElementById(firstErrorField.id);
            if(element){
                const tab = element.dataset.tab2 || '';
                if(tab){
                    setActiveKey(tab);
                    setTimeout(()=> {
                        console.log(element)
                        element.focus()
                    }, 200);
                }
            }
 
        }
     }, [firstErrorField]);

    const onNCMChange = (value) => {
        produto.fillNCM(value);
        dispatch(atualizaProduto(produto.toPlainJson()));
    }
    

    const onChangeTabHandler = (tab)=>{
        setActiveKey(tab);
    }

 
    return (
        <Row gutter={[16, 16]}>
            <Col sm={24}>
                <Tabs size="small" type="card" activeKey={activeKey} onChange={onChangeTabHandler}>
                    <TabPane tab="Geral" key="geral">                        
                        <Row>
                            <Col sm={24}>
                                <Form.Item label="Origem do Produto" name="origem">
                                    <Select data-tab2="geral" data-tab={dataTab}>
                                        <Option value={"0"}>0 - Nacional, exceto as indicadas nos códigos 3, 4, 5 e 8</Option>
                                        <Option value={"1"}>1 - Estrangeira - Importação direta, exceto a indicada no código 6</Option>
                                        <Option value={"2"}>2 - Estrangeira - Adquirida no mercado interno, exceto a indicada no código 7</Option>
                                        <Option value={"3"}>3 - Nacional, mercadoria ou bem com Conteúdo de Importação superior a 40% e inferior ou igual a 70%</Option>
                                        <Option value={"4"}>4 - Nacional, cuja produção tenha sido feita em conformidade com os processos produtivos básicos de que tratam as legislações citadas nos Ajustes</Option>
                                        <Option value={"5"}>5 - Nacional, mercadoria ou bem com Conteúdo de Importação inferior ou igual a 40%</Option>
                                        <Option value={"6"}>6 - Estrangeira - Importação direta, sem similar nacional, constante em lista da CAMEX e gás natural</Option>
                                        <Option value={"7"}>7 - Estrangeira - Adquirida no mercado interno, sem similar nacional, constante lista CAMEX e gás natural.</Option>
                                        <Option value={"8"}>8 - Nacional, mercadoria ou bem com Conteúdo de Importação superior a 70%</Option>
                                    </Select>
                                </Form.Item>
                            </Col>
                        </Row>
                        <Row gutter={[16,16]}>
                            <Col sm={6}>
                                <Form.Item maxLength={8} label="NCM"  name="ncm" >
                                    <InputNCM getApi={getApi} onChange={onNCMChange} data-tab={dataTab} data-tab2="geral" />
                                </Form.Item>
                            </Col>
                            <Col sm={6}>
                                <Form.Item label="CEST" name="cest">
                                    <Input data-tab={dataTab} data-tab2="geral" />
                                </Form.Item>
                            </Col>
                            <Col sm={6}>
                                <Form.Item label="EXTIPI" name="extipi">
                                    <Input data-tab={dataTab} data-tab2="geral" />
                                </Form.Item>
                            </Col>
                            <Col sm={6}>
                                <Form.Item label="%Aprox de Imposto" name="porcentagemAproximadaImpostos">
                                    <Input data-tab={dataTab} data-tab2="geral" />
                                </Form.Item>
                            </Col>
                            <Col sm={6}>
                                <Form.Item label="Cod Enq IPI (Se houver)" name="cEnqIPI">
                                    <Input data-tab={dataTab} data-tab2="geral"  />
                                </Form.Item>
                            </Col>
                        </Row>                            
                    </TabPane>
                    <TabPane tab="Combustíveis" key="combustivel">
                        <Row gutter={[16, 16]}>
                            <Col span={16}>
                                <Form.Item label="É Combustível?" name="ehCombustivel" initialValue={"NAO"}>
                                    <Select data-tab={dataTab} data-tab2="combustivel">
                                        <Option value="NAO">NÃO, esse produto não é Combustível ou Derivado de petróleo</Option>
                                        <Option value="SIM">SIM, esse produto é Combustível ou Derivado de petróleo</Option>
                                    </Select>
                                </Form.Item>
                            </Col>
                            <Col span={8}>
                                <Form.Item label="Código ANP" name="cProdANP">
                                    <Input data-tab={dataTab} data-tab2="combustivel"/>
                                </Form.Item>
                            </Col>
                            <Col span={24}>
                                <Form.Item label="Descrição ANP" name="descANP">
                                    <Input data-tab={dataTab} data-tab2="combustivel" />
                                </Form.Item>
                            </Col>
                            {/* 
                            
                            
                            
                            
                            Registro CODIF
                            
*/}
                            <Col span={10} >
                                <Form.Item label="% do GLP derivado do petroleo no produto GLP" name="pGLP">
                                    <InputNumero addonAfter={"%"}  data-tab={dataTab} data-tab2="combustivel"/>
                                </Form.Item>
                            </Col>

                            <Col span={7}>
                                <Form.Item label="Percentual de Gás Natural Nacional" name="`pGNn`">
                                    <InputNumero  addonAfter={"%"}  data-tab={dataTab} data-tab2="combustivel"/>
                                </Form.Item>
                            </Col>

                            <Col span={7}>
                                <Form.Item label="Percentual de Gás Natural Importado" name="pGNi">
                                    <InputNumero  addonAfter={"%"} data-tab={dataTab} data-tab2="combustivel" />
                                </Form.Item>
                            </Col>


                            <Col span={12}>
                                <Form.Item label="Valor de Partida" name="vPart">
                                    <InputNumero  data-tab={dataTab} data-tab2="combustivel"/>
                                </Form.Item>
                            </Col>


                            <Col span={12}>
                                <Form.Item label="Registro CODIF" name="CODIF">
                                    <Input  data-tab={dataTab} data-tab2="combustivel"/>
                                </Form.Item>
                            </Col>

                        </Row>
                    </TabPane>
                </Tabs>
            </Col>
            
        </Row>
    )
}

export { TabTributacao }